import axios from "axios";
import Config from "config";

const getJobs = (page) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Config.baseURL}/jobs?page=${page}`, {})
      .then((res) => res.data)
      .then((posts) => (posts ? resolve(posts) : resolve([])))
      .catch((error) => console.log(error));
  });
};

const getJobsByCategory = (category, page) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Config.baseURL}/jobs?category=${category}&page=${page}`, {})
      .then((res) => res.data)
      .then((posts) => {
        posts ? resolve(posts) : resolve([]);
      })
      .catch((error) => console.log(error));
  });
};

const getJobsByCompany = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Config.baseURL}/jobsByCompany?id=${id}`, {})
      .then((res) => res.data)
      .then((posts) => {
        posts ? resolve(posts) : resolve([]);
      })
      .catch((error) => console.log(error));
  });
};

const getJob = (id) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Config.baseURL}/job?id=${id}`)
      .then((res) => res.data)
      .then((post) => resolve(post))
      .catch((error) => console.log(error));
  });
};

const publishJob = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/publish-job`, data)
      .then((res) => res.data)
      .then((loginResponse) => resolve(loginResponse))
      .catch((error) => console.log(error));
  });
};

const boostJob = (companyID) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/boost-job`, { companyID })
      .then((res) => res.data)
      .then((loginResponse) => resolve(loginResponse))
      .catch((error) => console.log(error));
  });
};

const search = (value) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${Config.baseURL}/search`, { value })
      .then((res) => res.data)
      .then((loginResponse) => resolve(loginResponse))
      .catch((error) => console.log(error));
  });
};

const relatedJobs = (category) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${Config.baseURL}/related-jobs?category=${category}`)
      .then((res) => res.data)
      .then((jobs) => resolve(jobs))
      .catch((error) => console.log(error));
  });
};

export default {
  getJobs,
  getJob,
  getJobsByCategory,
  getJobsByCompany,
  publishJob,
  boostJob,
  search,
  relatedJobs,
};
